import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { createForm } from 'rc-form';

import { GenericSimpleButton } from 'com-gyf-webcore-userinterfacecomponents';

//Se importa componente de mensaje de error ya definido en CambioContrasena
import MensajeError from '../../CambioContrasena/components/MensajeError';

import errorHandler from '../../../Common/Handlers/ErrorHandler';

class Login extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showPassword: false,
            adUserLogin: this.props.adUserLogin
        }
    }

    handleChange = (e) => {
        this.setState({ adUserLogin: e.target.value });
    }

    componentDidMount() {
        //Activo errorHandler.
        errorHandler(this.props);

        //PreLogin - Se comenta PreLogin para que el login por AD se haga de forma manual
        //this.props.preLoginFn();

        ////Si no es AD.
        //if (adUserError != undefined && adUserError != "") {
        //    this.props.loginFn(null);
        //}
        //else {
        //    //Si es AD.
        //    if (adAuthToken != undefined && adClaimsToken != undefined && adExecutionContext != undefined) {
        //        //Antes de hacer login por AD valido que no sea la ejecuci�n del onbeforeunload luego del redirect hecho por el logout con la X.
        //        if (esLoginDespuesDeRedirectPermaneciendoEnElSitio == false) {
        //            //Seteo los nuevos tokens
        //            document.cookie = "_authToken=" + adAuthToken;
        //            document.cookie = "_claimsToken=" + adClaimsToken;
        //            document.cookie = "_executionContext=" + adExecutionContext;

        //            this.props.loginFn(adExecutionContext);
        //        }
        //    }
        //}
    }

    componentWillReceiveProps(nextProps) {
        //Timer que oculta cartel
        if (nextProps.errorMessage) {
            setTimeout(() => {
                this.props.hidePopUp();
            }, 7000);
        }

        //Actualizo login si no hay nada en el state
        if (!this.state.adUserLogin)
            this.setState({ adUserLogin: nextProps.adUserLogin });
    }

    componentWillUnmount() {
        this.props.reiniciarState();
    }

    showPasswordHandle() {
        this.setState({ showPassword: !this.state.showPassword });
    }

    //Se agrega validaci�n custom del userInput ya que se maneja por el state del componente
    submit = (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.props.form.validateFields((err, values) => {
            if (!err.passwordInput) {
                if (this.state.adUserLogin) {
                    this.props.loginFn(this.state.adUserLogin, values.passwordInput)
                }
            }
        });
    }

    render() {
        const {
            loggedIn,
            loading,
            errorMessage,
            passwordChange,
            passwordChangeUser,
            configSession
        } = this.props;

        let errorUser, errorPassword;

        const { getFieldProps, getFieldError } = this.props.form;

        const validationRules = {
            'userInput': [{ required: true, message: 'Debe ingresar un usuario.'}],
            'passwordInput': [{ required: true, message: 'Debe ingresar una contrase\u00F1a.' }]
        };

        //Usar Mediator.GetNextStep
        if (loggedIn)
            return <Redirect to="/" />;

        if (passwordChange)
            return <Redirect to={"/cambiocontrasena/" + passwordChangeUser} />;

        if (loading)
            return <div className="loading" />;

        //Determina si el input de usuario va a estar bloqeuado o no
        let disabled = (configSession.TipoSeguridad != "GYF" && configSession.SoloUsuarioLoggeado) ? { 'disabled': 'disabled' } : {};

        return (
            <div className="container off-marco-container">
                <form className="off-marco login" onSubmit={this.submit} method="POST">
                    <div className="row bottom-separator-xs">
                        <div className="col-xs-12 image-gyf-color-login" />
                    </div>

                    <div className="row bottom-separator-xs">
                        <div className="col-xs-12 text-center">
                            <h4 className="form-signin-heading">Bienvenido, ingrese su usuario y contrase&#241;a.</h4>
                        </div>
                    </div>

                    {/*MSJE GLOBAL*/}
                    <MensajeError error={errorMessage} />

                    <div>
                        <div className="row bottom-separator-xs">
                            <div className="col-xs-12">
                                <div className="row">
                                    <div className="col-xs-12">
                                        <label className="label-primary">Usuario</label>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-xs-12">
                                        <input
                                            {...getFieldProps('userInput', { rules: validationRules['userInput'] }) }
                                            className={"form-control default-input " +
                                                ((errorMessage || (!this.state.adUserLogin &&
                                                    getFieldError('userInput'))) && "error")}
                                            id="userInput"
                                            name="userInput"
                                            type="text"
                                            maxLength="20"
                                            value={this.state.adUserLogin}
                                            onChange={this.handleChange}
                                            {...disabled} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        {(!this.state.adUserLogin && (errorUser = getFieldError('userInput'))) ?
                                            <label className="error">
                                                {errorUser.join(',')}
                                            </label> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row bottom-separator-lg">
                            <div className="col-xs-12">
                                <div className="row">
                                    <div className="col-xs-6">
                                        <label className="label-primary">Contrase&#241;a</label>
                                    </div>
                                    <div className="col-xs-6">
                                        <div className="pull-right">
                                            <span className={"clickable zmdi-"
                                                + (this.state.showPassword ? "eye-off" : "eye")}
                                                onClick={() => this.showPasswordHandle()} />
                                            <label className="label-primary label-eye clickable"
                                                onClick={() => this.showPasswordHandle()}>
                                                {(this.state.showPassword ? "Ocultar" : "Mostrar")}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        <input
                                            {...getFieldProps('passwordInput', { rules: validationRules['passwordInput'] }) }
                                            className={"form-control default-input " + 
                                                ((errorMessage || getFieldError('passwordInput')) && "error")}
                                            id="passwordInput"
                                            name="passwordInput"
                                            type={this.state.showPassword ? "input" : "password"} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12">
                                        {(errorPassword = getFieldError('passwordInput')) ?
                                            <label className="error">
                                                {errorPassword.join(',')}
                                            </label> : null}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row bottom-separator-xs">
                            <div className="col-xs-12">
                                <GenericSimpleButton
                                    text="INICIAR SESI&Oacute;N"
                                    id="login-button"
                                    buttonType="submit"
                                    buttonClass="btn btn-cta" />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }
}

export default createForm()(Login);


// WEBPACK FOOTER //
// ./Portico/App/Screens/Login/components/Login.js